var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('participation-view-content-container',{attrs:{"current-stage":_vm.currentStage,"grey-background":true}},[_c('open-questionnaire'),(_vm.isActivityLoaded)?_c('open-questionnaire-navbar',{staticClass:"float-bottom-navbar"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }